import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import type { IDeps, TIsNotVisible } from './models';
import { InvestEmitentsDetailCardIsNotVisible as Component } from './component';

export const InvestEmitentsDetailCardIsNotVisible = createWidgetWithErrorBoundary<
    IDeps,
    TIsNotVisible
>({})(Component);
